import { Box, Heading, Text } from '@chakra-ui/react';
import { OutlineButton } from './Button';
import ImageShimmer from '../ImageShimmer/ImageShimmer';

export default function SmallCard({
  card,
  index,
  length,
  dividers,
}: {
  card: {
    image: {
      sourceUrl: string;
      altText: string;
      width?: number;
      height?: number;
    };
    title: string;
    text?: string;
    button?: {
      text: string;
      url: string;
    };
  };
  index: number;
  length?: number;
  size?: number;
  dividers?: boolean;
}) {
  return (
    <Box
      position="relative"
      minH={{ lg: '100%' }}
      textAlign="center"
      maxW={{ base: '23rem', md: '30rem', lg: '21.125rem' }}
      mx="auto"
    >
      <Box py={{ lg: '1.125rem' }}>
        <ImageShimmer
          src={card.image.sourceUrl}
          alt={card.image.altText}
          width={card.image.width ? card.image.width : '220'}
          height={card.image.height ? card.image.height : '200'}
          style={{ objectFit: 'contain' }}
          layout="intrinsic"
        />
        <Box mt="4">
          <Box>
            <Heading as="h3" fontSize="1.5rem" lineHeight="1.75rem">
              {card.title}
            </Heading>
            <Text mt="4">{card.text}</Text>
            {card.button && card.button.url && (
              <OutlineButton href={card.button.url} mt="8">
                {card.button.text}
              </OutlineButton>
            )}
          </Box>
        </Box>
      </Box>
      {!(length - 1 === index) && length < 4 && dividers && (
        <Box
          display={{ base: 'none', lg: 'block' }}
          position="absolute"
          right={{ lg: '-0.6875rem', xl: '-1.25rem' }}
          top="0"
          w="0.0625rem"
          h="100%"
          bgColor="grey.300"
        />
      )}
    </Box>
  );
}
